import { render } from "./TheMyCollectionAppTag.vue?vue&type=template&id=1c83235c&scoped=true&ts=true"
import script from "./TheMyCollectionAppTag.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionAppTag.vue?vue&type=script&lang=ts"

import "./TheMyCollectionAppTag.vue?vue&type=style&index=0&id=1c83235c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c83235c"]])

export default __exports__